import Brand from "../Brand/Brand";
import styles from "./Footer.module.css";
import { footerLinks, footerNote } from "./Footer.controller";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Brand size="compact" />
      <div className={styles.footerLinks}>
        {footerLinks.map((link) => (
          <a key={link.href} href={link.href}>
            {link.label}
          </a>
        ))}
      </div>
      <div className={styles.footerNote}>{footerNote}</div>
    </footer>
  );
};

export default Footer;
